import { GroupingState } from "@tanstack/react-table";
import { useState } from "react";

export default () => {
	const [grouping, setGrouping] = useState<GroupingState>([]);

	return { grouping, setGrouping };
};
